import { validateFormat, validatePresence } from 'ember-changeset-validations/validators';
import type Supplier from 'volta/models/supplier';
import validateOnCheck from 'volta/validators/on-check';

import type { TUserType } from 'volta/models/types/user';

export default {
  firstName: [],
  lastName: [],
  email: [validateFormat({ type: 'email', allowBlank: true })],
  login: validatePresence(true),
  roles: validatePresence(true),
  userType: [validatePresence(true)],
  suppliers: [
    validateOnCheck({
      checkKeys: ['userType'],
      checkCondition: (suppliers: Supplier[], userType: TUserType) => {
        return userType === 'SUPPLIER' ? suppliers.length > 0 : true;
      },
      i18nType: 'empty'
    })
  ]
};
